import React from 'react';
import { clients } from '../mock';

export default function Clients() {
  const doubled = [...clients, ...clients];
  return (
    <section id="clients" className="py-16 bg-white border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="text-primary font-semibold uppercase tracking-wider text-sm">Trusted Partners</span>
          <h2 className="mt-2 text-2xl lg:text-3xl font-extrabold text-slate-900 font-display">Our Prestigious Clients</h2>
        </div>
      </div>
      <div className="marquee-wrap overflow-hidden">
        <div className="flex items-center gap-14 animate-marquee w-max">
          {doubled.map((src, i) => (
            <img
              key={i}
              src={src}
              alt="Client logo"
              className="h-14 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
